import {ErrorHandler, NgModule} from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import {HttpClientModule, HttpClient, HTTP_INTERCEPTORS} from '@angular/common/http';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
// import { AmplifyAuthenticatorModule } from '@aws-amplify/ui-angular';

// icons
import { TablerIconsModule } from 'angular-tabler-icons';
import * as TablerIcons from 'angular-tabler-icons/icons';

// perfect scrollbar
import { NgScrollbarModule } from 'ngx-scrollbar';

//Import all material modules
import { MaterialModule } from './material.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
//Import Layouts
import { FullComponent } from './layouts/full/full.component';
import { BlankComponent } from './layouts/blank/blank.component';
import {DashboardComponent} from "./viBytes/dashboard/dashboard.component";
import {LandingComponent} from "./pages/authentication/landing/landing.component";
import {AuthValidateComponent} from "./viBytes/auth-validate/auth-validate.component";

import { FilterPipe } from './pipe/filter.pipe';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import {AuthInterceptor} from "./services/auth.Interceptor";
import {GlobalErrorHandler} from "./services/error.handler";
import {PopupService} from "./services/popup.service";
import {MatNativeDateModule} from "@angular/material/core";
import {HttpErrorInterceptor} from "./services/httperror.interceptor";
import {DatePipe} from "@angular/common";
import {
  AppDialogComponent,
  AppDialogContentComponent,
  AppDialogDataComponent, AppDialogMenuComponent,
  AppDialogOverviewComponent, AppDialogSuccessComponent
} from "./pages/dialog/dialog.component";

export function HttpLoaderFactory(http: HttpClient): any {
  return new TranslateHttpLoader(http, './assets/i18n/', '.json');
}

@NgModule({
  declarations: [AppComponent, BlankComponent, FilterPipe,
    AppDialogOverviewComponent,
    AppDialogContentComponent,
    AppDialogDataComponent,
    AppDialogMenuComponent,
    AppDialogComponent,
    AppDialogSuccessComponent
  ],
  providers: [
    { provide: HTTP_INTERCEPTORS, useClass: AuthInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: HttpErrorInterceptor, multi: true },
    { provide: ErrorHandler, useClass: GlobalErrorHandler },
    PopupService,
    DatePipe

  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    HttpClientModule,
    BrowserAnimationsModule,
    FormsModule,
    ReactiveFormsModule,
    MaterialModule,
    TablerIconsModule.pick(TablerIcons),
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        deps: [HttpClient],
      },
    }),
    NgScrollbarModule,
    FullComponent,
    DashboardComponent,
    LandingComponent,
    AuthValidateComponent,
    MatNativeDateModule

  ],
  exports: [TablerIconsModule],
  bootstrap: [AppComponent],
})
export class AppModule {}
